import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DataManager } from '@syncfusion/ej2-data';
import { AutocompleteCustomAdaptor } from './autocomplete-custom-adaptor';
import { Observable, of } from 'rxjs';
import { MultiSelectItem } from './multi-select-item';
import { AutoCompleteComponent, AutoCompleteModule } from '@syncfusion/ej2-angular-dropdowns';
import { AfterViewInit } from '@angular/core';
import { tap } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.scss'],
    imports: [AutoCompleteModule, TranslateModule]
})
export class AutocompleteComponent implements OnInit, AfterViewInit {

  @ViewChild('autocomplete')
  public autocomplete: AutoCompleteComponent;

  @Input()
  public getDataFunction: (searchText: string) => Observable<string[] | MultiSelectItem[]>;

  @Input()
  public placeholder: string = "i18n.shared.search";

  @Input()
  public set value(value: any) {
    if (this._outputValue != value) {
      // set values to 'null' to force reset with data reload
      this._outputValue = value;
      if (this._outputValue) {
        this.autocomplete?.refresh();
      }
    }
  }

  @Input()
  public fields: Object;

  @Input()
  public enabled: boolean = true;

  @Input()
  public set isFormComponent(value: boolean) {
    if (value) {
      this.cssClass = "form-autocomplete";
    } else {
      this.cssClass = null;
    }
  }

  @Output()
  public valueChange: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  public touched: EventEmitter<void> = new EventEmitter();

  public get outputValue() {
    return this._outputValue;
  }

  public onSelect(data: any) {
    const value = data.itemData?.id ?? data.itemData ?? null;
    if (this._outputValue != value) {
      this._outputValue = value;
      this.valueChange.emit(this._outputValue);
    }
  }

  public onChange(args: any) {
    let value = args.itemData?.id ?? args.itemData ?? null;
    // if value is string and length is 0, set to null. or if value is NaN, set to null
    if (typeof value === 'string') {
      if (value.length === 0) {
        value = null;
      }
    } else {
      if (isNaN(value)) {
        value = null;
      }
    }
    if (value != this._outputValue) {
      this._outputValue = value;
      this.valueChange.emit(this._outputValue);
    }
  }

  public data: DataManager;
  private _outputValue: any;
  public isFirst = false;

  public cssClass = null;

  private filteredData: any[] = [];

  constructor() {
  }

  ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AutocompleteCustomAdaptor(this.getDataFunctionWrapped.bind(this)),
    });

    if (this.isFormComponent) {
      this.cssClass = "form-autocomplete";
    }
  }

  ngAfterViewInit() {
    //Detect when clear icon gets clicked
    this.autocomplete.element.addEventListener('input', e => {
      if (!this.isFirst) {
        this.isFirst = true;
        this.autocomplete.element.parentElement
          .querySelector('.e-clear-icon')
          .addEventListener('mousedown', args => {
            this.valueChange.emit();
          });
      }
    });
  }

  public refresh() {
    this.autocomplete.refresh();
  }

  public onBlur() {
    this.touched.emit();
    if (!this._outputValue && this.autocomplete.value) {
      setTimeout(() => {
        this.autocomplete.value = this._outputValue;
      }, 0);
    }
  }

  private getDataFunctionWrapped(searchText: string): Observable<string[] | MultiSelectItem[]> {
    if (!this.getDataFunction) {
      return of([]);
    }
    return this.getDataFunction(searchText).pipe(
      tap((data) => {
        this.filteredData = data;
      })
    );
  }
}
